// extracted by mini-css-extract-plugin
export default {"text":"OverText_text__wo8-s"};